<script setup>
import { onMounted, ref, watch } from 'vue';
import {
    formataDataHoraFromDb,
} from '@/commons/utils';

const props = defineProps({
    valor: Array
})

const valoresTabela = ref([])
const temPagamentoId = ref(false)

const atualizarTabela = () => {
    valoresTabela.value = props.valor;
    temPagamentoId.value = valoresTabela.value.some(item => item.pagamento_id !== undefined);
}

onMounted(() => {
    atualizarTabela();
})

watch(() => props.valor, () => {
    atualizarTabela();
}, { deep: true })
</script>

<template>
    <DataTable :value="valoresTabela" class="w-full">
        <Column header="Status" class="text-overflow-ellipsis" style="min-width: 16rem; max-width: 22rem;">
            <template #body="slotProps">
                <ColunaListas :titulo="slotProps.data.tipo_solicitacao_projeto_status || slotProps.data.tipo_pagamento_status || slotProps.data.tipo_contratacao_status || slotProps.data.tipo_solicitacao_pagamento_clt_status || slotProps.data.tipo_projeto_contrato_membro_status || slotProps.data.tiporelatoriosolicitacaostatus_nome || slotProps.data.tipo_solicitacao_administrativa_status">
                    <template #descricao>
                        Por {{ slotProps.data.pessoa_fisica_nome }} — Em {{ formataDataHoraFromDb(slotProps.data.data_criacao || slotProps.data.data_status) }}
                    </template>
                </ColunaListas>
            </template>
        </Column>

        <Column header="Justificativa" class="text-overflow-ellipsis" style="min-width: 16rem; max-width: 20rem;">
            <template #body="slotProps">
                <ColunaListas :titulo="slotProps.data.justificativa || 'Não informada'" />
            </template>
        </Column>
    </DataTable>
</template>